module.exports = "<div class=\"search-box\">\n    <span load-image=\"image/search.svg\" class=\"icon-small left\"></span>\n    <input type=\"text\"\n           [class.has-value]=\"!!value && warning\"\n           [(ngModel)]=\"value\"\n           placeholder=\"{{placeholder}}\"\n           (keyup)=\"onKeyUp($event)\"\n           #searchTextBox\n           [attr.aria-label]=\"ariaLabel\"/>\n    <span class=\"right\">\n        <i *ngIf=\"value\" class=\"fa fa-times\" (click)=\"onClearClick($event)\"></i>\n    </span>\n</div>"


//////////////////
// WEBPACK FOOTER
// ./src/app/search-box/search-box.component.html
// module id = ./src/app/search-box/search-box.component.html
// module chunks = main